export const CHAT_GET_ROOMS = 'CHAT_GET_ROOMS'
export const CHAT_GET_MESSAGES = 'CHAT_GET_MESSAGES'
export const CHAT_CHANGE_ROOM = 'CHAT_CHANGE_ROOM'

export const CHAT_ADD_ROOM = 'CHAT_ADD_ROOM'
export const CHAT_DELETE_ROOM = 'CHAT_DELETE_ROOM'
export const CHAT_SEND_MSG = 'CHAT_SEND_MSG'

